
function BottomCoupon() {
    return (
        <div className="bottom_coupon shake-horizontal">
            <img className="slide-top-1" src="./assets/coupon_bottom.png" alt="" />
        </div>);
}

export default BottomCoupon;